$('.action-flip-skills').on('click', function(){
  $('.page.skills .container').toggleClass('transition');
});

$('.portfolio-item').on('click', function(e) {
  var isModalLink = $(this).hasClass('modal');
  e.preventDefault();
  if(layout.isDesktop()) {
    e.stopPropagation();
    $(this).toggleClass('flipped');
    $(this).siblings().removeClass('flipped');
  } else if (isModalLink) {
    e.stopPropagation();
    var info = portfolioItems[$(this).find('.open-modal').attr('portfolio-item')];
    showModal(info);
  } else {
    var location = $(this).find('.project-description > .btn').attr('href');
    window.open(location, "_blank");
  }
});

$('.portfolio-item .project-description a').on('click', function(e){
  e.stopPropagation();
  $(this).parent().trigger('click');
});

$('body').on('click', function(e){
  e.stopPropagation();
  $('.portfolio-item').removeClass('flipped');
});

$('.portfolio-item .open-modal').on('click', function(e){
  e.preventDefault();
  e.stopPropagation();
  var info = portfolioItems[$(this).attr('portfolio-item')];
  showModal(info);
});

$(document).keyup(function(e) {
  if(e.keyCode === 27) {
    hideModal();
  }
});

$('body').on('click', function(e) {
  if ($('body').hasClass('modal-show') && !$(e.target).closest('.modalContainer').length) {
    hideModal();
  }
});
